/*
 * カートドロワー。
 *
 * 価格・数量・割引の権威はサーバーにあり、この JS は金額を計算しない。
 * 操作はすべて Cart Ajax API に sections パラメータを付けて投げ、返却された HTML で
 * ドロワーの中身 (.anok-cart-drawer__top の innerHTML) を差し替える。
 * 設計: docs/sale-pricing-and-cart-design.md §5
 */
(function () {
  'use strict';

  var drawer = document.getElementById('anok-cart-drawer');
  if (!drawer) return;

  var SECTION_ID = 'anok-cart-drawer';
  var CONTENTS_SELECTOR = '.anok-cart-drawer__top';
  var DEBOUNCE_MS = typeof ON_CHANGE_DEBOUNCE_TIMER !== 'undefined' ? ON_CHANGE_DEBOUNCE_TIMER : 300;

  var cartButton = document.getElementById('cart-icon-bubble');
  var isClosing = false;
  var inflight = 0;

  // ========== 通信 ==========

  // カートページが同一ページに存在する場合は、その section もまとめて要求する
  // (ドロワーで数量を変えた時にカートページの表示が取り残されないように)。
  function sectionsToRequest() {
    var list = [SECTION_ID];
    if (document.getElementById('main-cart-items')) list.push('anok-cart');
    return list.join(',');
  }

  function cartFetch(url, body) {
    body.sections = sectionsToRequest();
    body.sections_url = window.location.pathname;

    setBusy(true);
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        applyState(state);
        return state;
      })
      .catch(function () {
        announce(window.cartStrings ? window.cartStrings.error : '更新中にエラーが発生しました。');
      })
      .then(function (state) {
        setBusy(false);
        return state;
      });
  }

  // 返却 HTML でドロワーの中身を差し替える。DOM 構造を保つため innerHTML のみ入れ替える
  // (ラッパー要素を挟むと .anok-cart-drawer__top の flex レイアウトが崩れるため)。
  function applyState(state) {
    if (!state) return;

    if (state.status || state.errors) {
      announce(state.description || state.message || (window.cartStrings && window.cartStrings.error));
      return;
    }

    var html = state.sections && state.sections[SECTION_ID];
    if (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var next = parsed.querySelector(CONTENTS_SELECTOR);
      var current = drawer.querySelector(CONTENTS_SELECTOR);
      if (next && current) current.innerHTML = next.innerHTML;
    }

    applyCartPageSections(state);
    updateHeaderBadge(readItemCount());
  }

  // カートページ側の差し替え領域 (cart.js の getSectionsToRender と対) を更新する。
  var CART_PAGE_TARGETS = [
    ['main-cart-items', '#main-cart-items .js-contents'],
    ['main-cart-footer', '#main-cart-footer .js-contents'],
    ['main-cart-cross-sell', '#main-cart-cross-sell .js-contents']
  ];

  function applyCartPageSections(state) {
    var html = state.sections && state.sections['anok-cart'];
    if (!html) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    CART_PAGE_TARGETS.forEach(function (pair) {
      var host = document.getElementById(pair[0]);
      if (!host) return;
      var next = doc.querySelector(pair[1]);
      if (!next) return;
      var target = host.querySelector('.js-contents') || host;
      target.innerHTML = next.innerHTML;
    });

    // 空カート時の表示切り替え (cart.js と同じ扱い)
    var count = readItemCount();
    var cartItems = document.querySelector('cart-items');
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartItems) cartItems.classList.toggle('is-empty', count === 0);
    if (cartFooter) cartFooter.classList.toggle('is-empty', count === 0);
  }

  // item_count は差し替えた HTML 内の data-cart-count から読む。
  // /cart/add.js のレスポンス自体は line item であり item_count を含まないため。
  function readItemCount() {
    var el = drawer.querySelector('[data-cart-count]');
    if (!el) return null;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? null : n;
  }

  function setBusy(on) {
    inflight += on ? 1 : -1;
    if (inflight < 0) inflight = 0;
    if (inflight > 0) drawer.setAttribute('busy', '');
    else drawer.removeAttribute('busy');
  }

  function setItemLoading(key, on) {
    var item = drawer.querySelector('.anok-cart-drawer__item[data-cart-item="' + key + '"]');
    if (item) item.classList.toggle('is-loading', !!on);
  }

  function announce(message) {
    var region = drawer.querySelector('[data-cart-live-region]');
    if (region && message) region.textContent = message;
  }

  function updateHeaderBadge(count) {
    if (!cartButton || count === null) return;
    var badge = cartButton.querySelector('.anok-shop-header__cart-count');
    if (count > 0) {
      if (badge) {
        badge.textContent = count;
      } else {
        var newBadge = document.createElement('span');
        newBadge.className = 'anok-shop-header__cart-count';
        newBadge.textContent = count;
        cartButton.appendChild(newBadge);
      }
    } else if (badge) {
      badge.remove();
    }
  }

  // ========== カート操作 ==========

  // id には line item key を渡す (variant_id でも可だが、同一 variant が
  // properties 違いで複数行になった場合に区別できないため key を使う)。
  function changeItem(key, quantity) {
    setItemLoading(key, true);
    return cartFetch(window.routes.cart_change_url, { id: key, quantity: quantity });
  }

  function addVariant(variantId, quantity) {
    return cartFetch(window.routes.cart_add_url, {
      items: [{ id: variantId, quantity: quantity || 1 }]
    });
  }

  // 削除は縮小フェードを見せてからサーバーに送る (突然消える印象を緩和)。
  function removeItemWithAnim(key) {
    var el = drawer.querySelector('.anok-cart-drawer__item[data-cart-item="' + key + '"]');
    if (!el) { changeItem(key, 0); return; }

    el.style.height = el.offsetHeight + 'px';
    el.classList.add('is-removing');
    requestAnimationFrame(function () {
      el.style.height = '0';
      el.style.opacity = '0';
      el.style.paddingTop = '0';
      el.style.paddingBottom = '0';
    });

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      changeItem(key, 0);
    }
    el.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'height') finish();
    });
    setTimeout(finish, 400); // transitionend が来ない場合のフォールバック
  }

  // 連打を 1 リクエストに畳む。行ごとにタイマーを持ち、最後の値だけを送る。
  var qtyTimers = {};
  function queueQtyChange(key, quantity) {
    setItemLoading(key, true);
    if (qtyTimers[key]) clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      changeItem(key, quantity);
    }, DEBOUNCE_MS);
  }

  // ========== 開閉 ==========

  function openDrawer() {
    isClosing = false;
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollbarWidth + 'px';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    drawer.setAttribute('open', '');
  }

  function closeDrawer() {
    if (isClosing) return;
    isClosing = true;
    var panel = drawer.querySelector('.anok-cart-drawer__panel');

    drawer.setAttribute('closing', '');
    drawer.removeAttribute('open');

    function handleTransitionEnd(e) {
      if (e.target === panel) {
        drawer.removeAttribute('closing');
        isClosing = false;
        panel.removeEventListener('transitionend', handleTransitionEnd);
      }
    }
    if (panel) panel.addEventListener('transitionend', handleTransitionEnd);
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  // ========== 公開 API ==========

  window.anokCartDrawer = {
    open: openDrawer,
    // cart.js (カートページ) がドロワーを差し替えた後に呼ぶ
    refreshBadge: function () {
      updateHeaderBadge(readItemCount());
    },
    // variantId を受ける。旧署名 (itemData オブジェクト) で呼ばれた場合も id を拾う。
    addItem: function (variantIdOrItem, qty) {
      var id = variantIdOrItem;
      if (id && typeof id === 'object') id = id.id || id.key;
      id = parseInt(id, 10);
      if (!id) return Promise.resolve();
      openDrawer();
      return addVariant(id, qty || 1);
    }
  };

  // ========== イベント ==========

  if (cartButton) {
    cartButton.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.hasAttribute('open')) closeDrawer();
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      closeDrawer();
      return;
    }

    var btn = e.target.closest('[data-cart-qty-btn]');
    if (!btn || drawer.hasAttribute('busy')) return;

    var key = btn.dataset.key;
    if (!key) return;

    if (btn.dataset.action === 'remove') {
      removeItemWithAnim(key);
      return;
    }

    var input = drawer.querySelector('.anok-cart-drawer__qty-input[data-key="' + key + '"]');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var next = btn.dataset.action === 'increase' ? current + 1 : current - 1;

    if (next < 1) {
      removeItemWithAnim(key);
      return;
    }

    input.value = next; // 見た目を即時反映し、確定はサーバー応答で行う
    queueQtyChange(key, next);
  });

  drawer.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var key = input.dataset.key;
    var qty = parseInt(input.value, 10);
    if (!key) return;
    if (isNaN(qty) || qty < 1) { removeItemWithAnim(key); return; }
    queueQtyChange(key, qty);
  });

  // ========== 移行措置 (削除予定: 2026-12 目安) ==========
  //
  // 旧実装は localStorage 'anok_cart' をカートの正としており、追加時にサーバーへ送っていなかった。
  // 移行版の初回訪問でその内容をサーバーカートへ引き継がないと、利用者からは
  // 「カートに入れた商品が消えた」ように見えるため、1 回だけマージして旧データを破棄する。
  // 十分に時間が経ったら (旧 localStorage を持つ訪問者がいなくなったら) このブロックごと削除する。
  (function migrateLegacyCart() {
    var raw = null;
    try { raw = localStorage.getItem('anok_cart'); } catch (e) { return; }
    if (!raw) return;

    function clearLegacy() {
      try {
        localStorage.removeItem('anok_cart');
        localStorage.removeItem('anok_cart_checkout');
      } catch (e) { /* noop */ }
    }

    var legacy;
    try { legacy = JSON.parse(raw); } catch (e) { clearLegacy(); return; }
    if (!legacy || !legacy.items || !legacy.items.length) { clearLegacy(); return; }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (server) {
        var have = {};
        (server.items || []).forEach(function (i) { have[String(i.id)] = i.quantity; });

        var toAdd = [];
        legacy.items.forEach(function (i) {
          var id = parseInt(i.id != null ? i.id : i.key, 10);
          if (!id) return;
          var diff = (i.quantity || 0) - (have[String(id)] || 0);
          if (diff > 0) toAdd.push({ id: id, quantity: diff });
        });

        clearLegacy(); // 送信可否にかかわらず旧データは破棄する (二重加算の防止)
        if (toAdd.length) return cartFetch(window.routes.cart_add_url, { items: toAdd });
      })
      .catch(clearLegacy);
  })();
})();
